<template>
    <div class="main_container">
        <div class="search-box" id="searchBox">
            <div @click="showMore" class="showMoreBtn">
                <i class="iconfont icon-you" v-bind:class="{'icon-shang': isShowMore}"></i>
                <span>{{$t('message.Search')}}</span>
            </div>
            <div v-show="isShowMore">
                <el-form :label-width="labelW" :model="ruleForm" ref="ruleForm">
                    <el-form-item :label="$t('message.ItemID')" prop="ItemID">
                        <el-input placeholder=" "
                                  v-model="ruleForm.ItemID"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.ItemContent')" prop="ItemContent">
                        <el-input placeholder=" "
                                  v-model="ruleForm.ItemContent"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.CultureCode')" prop="CultureCode">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.CultureCode">
                            <el-option
                                    :key="index"
                                    :label="item.Text"
                                    :value="item.Value"
                                    v-for="(item, index) in languageTypeOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="button-line">
                        <el-form-item>
                            <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                                <el-button @click="submitForm('ruleForm')" class="icon iconfont icon-sousuo"
                                           type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                                <el-button @click="resetForm('ruleForm')"
                                           class="icon iconfont icon-zhongzhi"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table_container" v-loading="isLoading">
            <el-button-group>
                <el-tooltip :content="$t('message.Add')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="icon iconfont icon-xinzeng-wubiankuang"
                               type="primary"></el-button>
                </el-tooltip>
            </el-button-group>
            <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                    :height="tableHeight"
                    :max-height="tableHeight"
                    :row-key="row => row.index"
                    class="table_list table_border"
                    ref="multipleTable"
                    stripe>
                <el-table-column
                        :label="$t('message.ItemID')"
                        :min-width="120"
                        prop="ItemID">
                </el-table-column>
                <el-table-column
                        :label="$t('message.ItemContent')"
                        :min-width="250"
                        :show-overflow-tooltip="true"
                        prop="ItemContent">
                </el-table-column>
                <el-table-column
                        :label="$t('message.CultureCode')"
                        :min-width="80"
                        prop="CultureCode">
                </el-table-column>
                <el-table-column :label="$t('message.Operating')" width="90">
                    <template slot-scope="scope">
                        <el-tooltip
                                :content="$t('message.Edit')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleEdit(scope.row)"
                                    class="hoverBtn iconfont icon-bianji-kong"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Delete')"
                                class="item"
                                effect="dark"
                                placement="top">
                            <el-button
                                    @click="handleDelete(scope.row.Id)"
                                    class="hoverBtn iconfont icon-shanchu-kong"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :total="count"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        background
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="$t('message.LanguageManage')"
                :visible.sync="dialogVisible"
                class="form_dialog"
                width="500px">
            <el-form :label-width="labelW" :model="languageForm" :rules="languageFormRules" ref="languageForm">
                <el-form-item :label="$t('message.ItemID')" prop="ItemID">
                    <el-input placeholder=" "
                              v-model="languageForm.ItemID"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.ItemContent')" prop="ItemContent">
                    <el-input :rows="2"
                              placeholder=" "
                              type="textarea"
                              v-model="languageForm.ItemContent"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.CultureCode')" prop="language">
                    <el-select filterable placeholder=" "
                               v-model="languageForm.CultureCode">
                        <el-option
                                :key="index"
                                :label="item.Text"
                                :value="item.Value"
                                v-for="(item, index) in languageTypeOptions">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Cancel')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogVisible = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('message.Save')" class="item" effect="dark" placement="top">
                    <el-button @click="doLanguage('languageForm')" class="iconfont icon-baocun1"
                               type="primary"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {GetLanguageResource, CreateUpdLanguageResource, DelLanguageResourceById} from "../api/apiLanguage";
    import {removeStore, getLocal} from "../config/mUtils";

    export default {
        name: 'language',
        data() {
            return {
                labelW: 0 + 'px',
                isShowMore: false,
                languageTypeOptions: [
                    {
                        Value: "zh-CN",
                        Text: '中文'
                    },
                    {
                        Value: "en-US",
                        Text: 'English'
                    }
                ],
                ruleForm: {
                    ItemID: '',
                    ItemContent: '',
                    CultureCode: ''
                },
                languageForm: {
                    ItemID: '',
                    ItemContent: '',
                    CultureCode: ''
                },
                languageFormRules: {
                    ItemID: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.ItemID"),
                        trigger: "blur"
                    },
                    ItemContent: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.ItemContent"),
                        trigger: "blur"
                    },
                    CultureCode: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseSelect") + this.$t("message.CultureCode"),
                        trigger: "blur"
                    }
                },
                languageId: '',
                tableHeight: 0,
                isLoading: false,
                tableData: [],
                offset: 1,
                limit: 10,
                count: 0,
                currentPage: 1,
                dialogVisible: false,
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.watchHeight();
            this.initData();
            this.resetLabelWidth();
            removeStore('OCRData');
            removeStore('changedInvoiceIndexData');
        },
        mounted() {
            setTimeout(() => {
                let widowHeight = document.documentElement.clientHeight - 275;
                let h = document.getElementById('searchBox').clientHeight;
                this.tableHeight = widowHeight - h;
            }, 1);
        },
        computed: {
            canResetH() {
                return this.isShowMore;
            },
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            canResetH() {
                setTimeout(() => {
                    let widowHeight = document.documentElement.clientHeight - 275;
                    let h = document.getElementById('searchBox').clientHeight;
                    this.tableHeight = widowHeight - h;
                }, 1);
            },
            langChange(val) {
                if (val) {
                    this.isShowMore = false;
                    this.resetLabelWidth();
                    setTimeout(() => {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        this.tableHeight = widowHeight - h;
                    }, 1);
                }
            }
        },
        methods: {
            watchHeight() {
                setTimeout(() => {
                    const that = this;
                    window.onresize = function temp() {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        that.tableHeight = widowHeight - h;
                    };
                }, 1);
            },
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.labelW = 100 + 'px';
                } else {
                    this.labelW = 100 + 'px';
                }
            },
            showMore() {
                this.isShowMore = !this.isShowMore;
            },
            async initData() {
                try {
                    this.getLanguageResource();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取多语言列表
            async getLanguageResource() {
                this.isLoading = true;
                this.tableData = [];
                try {
                    let data = await GetLanguageResource(
                        this.ruleForm.ItemID,
                        this.ruleForm.ItemContent,
                        this.ruleForm.CultureCode,
                        getLocal('language'),
                        this.offset,
                        this.limit
                    );
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.count = data.data.sysLanguageResourceCount;
                        this.tableData = data.data.sysLanguageResourceReturn;
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 更改每页显示数据条数
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.offset = 1;
                this.getLanguageResource();
            },
            // 更改当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.offset = val;
                this.getLanguageResource();
            },
            // 搜索
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getLanguageResource();
                    } else {
                        return false;
                    }
                });
            },
            // 重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.offset = 0;
                this.currentPage = 1;
                this.getLanguageResource();
            },
            // 新增
            handleAdd() {
                this.languageId = '';
                this.dialogVisible = true;
                this.languageForm = {
                    ItemID: '',
                    ItemContent: '',
                    CultureCode: '',
                };
                this.$nextTick(() => {
                    this.$refs['languageForm'].resetFields();
                });
            },
            // 编辑
            handleEdit(row) {
                this.languageId = row.Id;
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs['languageForm'].resetFields();
                    this.languageForm = {
                        ItemID: row.ItemID,
                        ItemContent: row.ItemContent,
                        CultureCode: row.CultureCode,
                    };
                });
            },
            // 新增、编辑多语言
            async createUpdLanguageResource() {
                try {
                    let data = await CreateUpdLanguageResource(
                        this.languageId,
                        this.languageForm.ItemID,
                        this.languageForm.ItemContent,
                        this.languageForm.CultureCode,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.SaveSuccessful'));
                        this.dialogVisible = false;
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getLanguageResource();
                    } else {
                        this.$message.error(this.$t('message.SaveFailed'));
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            //保存
            doLanguage() {
                this.$refs['languageForm'].validate((valid) => {
                    if (valid) {
                        this.createUpdLanguageResource();
                    }
                });
            },
            // 删除多语言
            async delLanguage(Id) {
                try {
                    let data = await DelLanguageResourceById(
                        Id,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.DeleteSuccessful'));
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getLanguageResource();
                    } else {
                        this.$message.error(this.$t('message.DeleteFailed'));
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 删除
            handleDelete(Id) {
                this.delLanguage(Id);
            }
        }
    }
</script>

<style scoped>

</style>
